import React, { useState, useEffect } from 'react';
import apiClient from '../../Api/apiClient';
import Swal from 'sweetalert2';

const TenderRequestUpdateForm = ({ tenderID }) => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    designation: '',
    organization_name: '',
    tender_name: '',
    tender_file: null,
    company_logo: null,
    company_phone_number: '',
    company_name: '',
  });

  const [errors, setErrors] = useState({});
  const [companyLogoPreview, setCompanyLogoPreview] = useState(null);
  const [tenderFileName, setTenderFileName] = useState(null);
  const [fileName, setFileName] = useState('');
  const [ImageFile, setImageFile] = useState('');
  const userType = localStorage.getItem('user_type');



  // Fetch tender data based on tenderID
  // const fetchTenderData = async () => {
  //   if (!tenderID) return;

  //   try {
  //     const apiEndpoint =
  //       userType === 'end_user'
  //         ? `/user/tender-end-user/tender-request/${tenderID}`
  //         : userType === 'user'
  //           ? `/user/tender-user/tender-request/${tenderID}`
  //           : userType === 'affiliator'
  //             ? `/affiliator/tender-request/publish-tender/${tenderID}`
  //             : '';
  //     const response = await apiClient.get(
  //       apiEndpoint
  //     );
  //     const {
  //       name,
  //       email,
  //       phone,
  //       designation,
  //       organization_name,
  //       tender_name,
  //       tender_file,
  //       company_logo,
  //       company_phone_number,
  //       company_name
  //     } = response.data.data;

  //     setFormData({
  //       name: name || '',
  //       email: email || '',
  //       phone: phone || '',
  //       designation: designation || '',
  //       organization_name: organization_name || '',
  //       tender_name: tender_name || '',
  //       tender_file: tender_file || null,
  //       company_logo: company_logo || null,
  //       company_phone_number: company_phone_number || "",
  //       company_name: company_name || ""
  //     });

  //     // Set previews for file-based fields
  //     if (company_logo) {
  //       // setCompanyLogoPreview(`${company_logo}`);
  //       setCompanyLogoPreview(company_logo.split('/').pop());
  //     } else {
  //       setCompanyLogoPreview('not provided'); // Display "null" if company_logo is not available
  //     }
  //     if (tender_file) {
  //       setTenderFileName(tender_file.split('/').pop());
  //     } else {
  //       setTenderFileName('not provided'); // Display "null" if company_logo is not available
  //     }

  //   } catch (error) {
  //     console.error('Error fetching tender data:', error);
  //   }
  // };

  const fetchTenderData = async () => {
    if (!tenderID) return;

    try {
      const apiEndpoint =
        userType === 'end_user'
          ? `/user/tender-end-user/tender-request/${tenderID}`
          : userType === 'user'
            ? `/user/tender-user/tender-request/${tenderID}`
            : userType === 'affiliator'
              ? `/affiliator/tender-request/publish-tender/${tenderID}`
              : '';
      const response = await apiClient.get(apiEndpoint);
      const {
        name,
        email,
        phone,
        designation,
        organization_name,
        tender_name,
        tender_file,
        company_logo,
        company_phone_number,
        company_name,
      } = response.data.data;

      setFormData({
        name: name || '',
        email: email || '',
        phone: phone || '',
        designation: designation || '',
        organization_name: organization_name || '',
        tender_name: tender_name || '',
        tender_file: tender_file || null,
        company_logo: company_logo || null,
        company_phone_number: company_phone_number || '',
        company_name: company_name || '',
      });

      // Set existing file names
      if (tender_file) {
        setTenderFileName(tender_file.split('/').pop());
      } else {
        setTenderFileName('not provided');
      }
      if (company_logo) {
        setCompanyLogoPreview(company_logo.split('/').pop());
      } else {
        setCompanyLogoPreview('not provided');
      }
    } catch (error) {
      console.error('Error fetching tender data:', error);
    }
  };

  useEffect(() => {
    fetchTenderData();
  }, [tenderID]);

  const handleChange = (e) => {
    const { name, type, files, value } = e.target;

    if (type === 'file') {
      const file = files[0];
      if (name === 'tender_file') {
        setFileName(file ? file.name : tenderFileName); // Use existing file name if no new file is selected
      }
      if (name === 'company_logo') {
        setImageFile(file ? file.name : companyLogoPreview); // Use existing file name if no new file is selected
      }
      setFormData((prevData) => ({
        ...prevData,
        [name]: file || prevData[name], // Retain existing file if no new file is selected
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formdata = new FormData();
    formdata.append('name', formData.name);
    formdata.append('tender_name', formData.tender_name);
    formdata.append('phone', formData.phone);
    formdata.append('email', formData.email);
    formdata.append('designation', formData.designation);
    formdata.append('organization_name', formData.organization_name);
    formdata.append('company_phone_number', formData.company_phone_number);
    formdata.append('company_name', formData.company_name);

    // Append tender file
    if (formData.tender_file) {
      formdata.append('tender_file', formData.tender_file); // Append new file
    } else if (tenderFileName && tenderFileName !== 'not provided') {
      formdata.append('tender_file', tenderFileName); // Append existing file name
    }

    // Append company logo
    if (formData.company_logo) {
      formdata.append('company_logo', formData.company_logo); // Append new file
    } else if (companyLogoPreview && companyLogoPreview !== 'not provided') {
      formdata.append('company_logo', companyLogoPreview); // Append existing file name
    }

    try {
      const apiEndpoint =
        userType === 'end_user'
          ? `/user/tender-end-user/tender-request/${tenderID}`
          : userType === 'user'
            ? `/user/tender-user/tender-request/${tenderID}`
            : userType === 'affiliator'
              ? `/affiliator/tender-request/publish-tender/${tenderID}`
              : '';
      const response = await apiClient.patch(apiEndpoint, formdata, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      Swal.fire('Success!', response.data.message, 'success');
    } catch (error) {
      console.error('Error during submission:', error);
      const errorMessage = error.response?.data?.message;
      Swal.fire('Error!', errorMessage, 'error');
    }
  };

  const handleRemovePDF = () => {
    setFileName(""); // Clear the file name
    document.getElementById("tender_file").value = ""; // Reset the file input
  };

  const handleRemovePic = () => {
    setImageFile(""); // Clear the image file name
    document.getElementById("company_logo").value = ""; // Reset the file input
  };


  return (
    <div className="bg-publishTenderFormBackground p-4 2xl:p-6 border border-gray-400 rounded-md text-[10px] 2xl:text-xs">
      <form onSubmit={handleSubmit} className="2xl:space-y-4 space-y-2">
        {/* Tender Name Field */}
        <div className="flex items-center flex-col md:flex-row lg:flex-row ">
          <label
            htmlFor="tender_name"
            className="font-medium text-gray-700 w-full md:w-1/3"
          >
            Tender Name*
          </label>
          <input
            id="tender_name"
            name="tender_name"
            type="text"
            value={formData.tender_name}
            onChange={handleChange}
            placeholder="Enter tender's name"
            required
            className={`w-full md:w-2/3 p-2 border-2 border-gray-400 rounded shadow-sm  ${errors.tender_name ? 'border-red-500' : ''
              }`}
          />
        </div>

        {/* Company Name */}
        <div className="flex items-center flex-col md:flex-row lg:flex-row ">
          <label
            htmlFor="company_name"
            className="font-medium text-gray-700 w-full  md:w-1/3"
          >
            Company Name*
          </label>
          <input
            id="company_name"
            name="company_name"
            type="text"
            value={formData.company_name}
            onChange={handleChange}
            placeholder="Enter company name"
            required
            className={`w-full md:w-2/3  p-2 border-2 border-gray-400 rounded shadow-sm ${errors.company_name ? 'border-red-500' : ''
              }`}
          />
        </div>

        {/* company phone */}
        <div className="flex items-center flex-col md:flex-row lg:flex-row ">
          <label
            htmlFor="phone"
            className="font-medium text-gray-700 w-full  md:w-1/3"
          >
            Company Number *
          </label>
          <input
            id="company_phone_number"
            name="company_phone_number"
            type="tel"
            value={formData.company_phone_number}
            onChange={handleChange}
            placeholder="Enter your company phone number"
            required
            className={`w-full md:w-2/3 p-2 border-2 border-gray-400 rounded shadow-sm  ${errors.phone ? 'border-red-500' : ''
              }`}
          />
        </div>

        <div className="flex items-center flex-col md:flex-row lg:flex-row">
          <label
            htmlFor="tender_file"
            className="font-semibold text-gray-700 w-full md:w-1/3"
          >
            Tender's File (PDF/Image)*
          </label>
          <div className="w-full md:w-2/3 flex items-center border-2 bg-white border-gray-400 rounded-md shadow-sm p-1">
            <input
              type="text"
              value={fileName || tenderFileName}
              placeholder="Choose your tender file"
              className="flex-1 w-full md:w-2/3 p-2 px-2"
              readOnly
              id="file_name_display"

            />
            {/* Choose File Button */}
            <label
              htmlFor="tender_file"
              className="bg-publishTenderChoosePDF text-black px-4 py-2 rounded-md cursor-pointer hover:bg-publishTenderFormBackground ml-2"
            >
              Choose PDF/Image
            </label>
            {/* Remove Button (conditionally rendered) */}
            {fileName && (
              <button
                type="button"
                onClick={handleRemovePDF}
                className="bg-red-500 text-white px-4 py-2 rounded-md cursor-pointer hover:bg-red-600 ml-2"
              >
                Remove
              </button>
            )}
            {/* Hidden File Input */}
            <input
              id="tender_file"
              name="tender_file"
              type="file"
              accept="application/pdf, image/png, image/jpeg, image/jpg"
              onChange={handleChange}
              className="hidden"
              value={formData.tender_file ? undefined : ''} // Reset value if no new file is selected
            />
          </div>
        </div>


        <div className="flex items-center flex-col md:flex-row lg:flex-row">
          <label
            htmlFor="company_logo"
            className="font-semibold text-gray-700 w-full md:w-1/3"
          >
            Company Logo
          </label>
          <div className="w-full md:w-2/3 flex items-center border-2 bg-white border-gray-400 rounded-md shadow-sm p-1">
            <input
              value={ImageFile || companyLogoPreview}
              placeholder="Choose company logo"
              className="flex-1 w-full md:w-2/3 p-2 px-2"
              readOnly
              id="company_name_display"

            />
            {/* Choose Image Button */}
            <label
              htmlFor="company_logo"
              className="bg-publishTenderChoosePDF text-black px-4 py-2 rounded-md cursor-pointer hover:bg-publishTenderForm2 ml-2"
            >
              Choose image
            </label>
            {/* Remove Button (conditionally rendered) */}
            {ImageFile && (
              <button
                type="button"
                onClick={handleRemovePic}
                className="bg-red-500 text-white px-4 py-2 rounded-md cursor-pointer hover:bg-red-600 ml-2"
              >
                Remove
              </button>
            )}
            {/* Hidden File Input */}
            <input
              id="company_logo"
              name="company_logo"
              type="file"
              accept="image/png, image/jpeg, image/jpg"

              onChange={handleChange}
              className="hidden"
            />
          </div>
        </div>

        {/* Name Field */}
        <div className="flex items-center flex-col md:flex-row lg:flex-row ">
          <label
            htmlFor="name"
            className="font-medium text-gray-700 w-full  md:w-1/3"
          >
            Name*
          </label>
          <input
            id="name"
            name="name"
            type="text"
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter your name"
            required
            className={`w-full md:w-2/3  p-2 border-2 border-gray-400 rounded shadow-sm  ${errors.name ? 'border-red-500' : ''
              }`}
          />
        </div>

        {/* Phone Field */}
        <div className="flex items-center flex-col md:flex-row lg:flex-row ">
          <label
            htmlFor="phone"
            className=" font-medium text-gray-700 w-full  md:w-1/3"
          >
            Phone *
          </label>
          <input
            id="phone"
            name="phone"
            type="tel"
            value={formData.phone}
            onChange={handleChange}
            placeholder="Enter your phone number"
            required
            className={`w-full md:w-2/3 p-2 border-2 border-gray-400 rounded shadow-sm  ${errors.phone ? 'border-red-500' : ''
              }`}
          />
        </div>

        {/* Email Field */}
        <div className="flex items-center flex-col md:flex-row lg:flex-row ">
          <label
            htmlFor="email"
            className="font-medium text-gray-700 w-full  md:w-1/3"
          >
            Email
          </label>
          <input
            id="email"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Enter your email"
            className={`w-full md:w-2/3  p-2 border-2 border-gray-400 rounded shadow-sm  ${errors.email ? 'border-red-500' : ''
              }`}
          />
        </div>

        {/* Organization Name Field */}
        <div className="flex items-center flex-col md:flex-row lg:flex-row ">
          <label
            htmlFor="organization_name"
            className=" font-medium text-gray-700 w-full md:w-1/3"
          >
            Organization Name
          </label>
          <input
            id="organization_name"
            name="organization_name"
            type="text"
            value={formData.organization_name}
            onChange={handleChange}
            placeholder="Enter your institute"
            className={`w-full md:w-2/3  p-2 border-2 border-gray-400 rounded shadow-sm  ${errors.organization_name ? 'border-red-500' : ''
              }`}
          />
        </div>

        {/* Designation Field */}
        <div className="flex items-center flex-col md:flex-row lg:flex-row ">
          <label
            htmlFor="designation"
            className="font-medium text-gray-700 w-full  md:w-1/3"
          >
            Designation
          </label>
          <input
            id="designation"
            name="designation"
            type="text"
            value={formData.designation}
            onChange={handleChange}
            placeholder="Enter your designation"
            className={`w-full md:w-2/3  p-2 border-2 border-gray-400 rounded shadow-sm ${errors.designation ? 'border-red-500' : ''
              }`}
          />
        </div>

        <div className="flex justify-end">
          <button
            type="submit"
            className="px-6 py-2 bg-orange-400 text-white rounded hover:bg-green-600 transition"
          >
            Update Tender
          </button>
        </div>
      </form>
    </div>
  );
};

export default TenderRequestUpdateForm;




// import React, { useState, useEffect } from 'react';
// import apiClient from '../../Api/apiClient';
// import Swal from 'sweetalert2';

// const TenderRequestUpdateForm = ({ tenderID }) => {
//   const [formData, setFormData] = useState({
//     name: '',
//     phone: '',
//     email: '',
//     designation: '',
//     organization_name: '',
//     tender_name: '',
//     tender_file: null,
//     company_logo: null,
//     company_phone_number: '',
//     company_name: '',
//   });

//   const [errors, setErrors] = useState({});
//   const [companyLogoPreview, setCompanyLogoPreview] = useState(null);
//   const [tenderFileName, setTenderFileName] = useState(null);
//   const [fileName, setFileName] = useState('');
//   const [ImageFile, setImageFile] = useState('');
//   const userType = localStorage.getItem('user_type');



//   // Fetch tender data based on tenderID
//   const fetchTenderData = async () => {
//     if (!tenderID) return;

//     try {
//       const apiEndpoint =
//         userType === 'end_user'
//           ? `/user/tender-end-user/tender-request/${tenderID}`
//           : userType === 'user'
//             ? `/user/tender-user/tender-request/${tenderID}`
//             : userType === 'affiliator'
//               ? `/affiliator/tender-request/publish-tender/${tenderID}`
//               : '';
//       const response = await apiClient.get(
//         apiEndpoint
//       );
//       const {
//         name,
//         email,
//         phone,
//         designation,
//         organization_name,
//         tender_name,
//         tender_file,
//         company_logo,
//         company_phone_number,
//         company_name
//       } = response.data.data;

//       setFormData({
//         name: name || '',
//         email: email || '',
//         phone: phone || '',
//         designation: designation || '',
//         organization_name: organization_name || '',
//         tender_name: tender_name || '',
//         tender_file: tender_file || null,
//         company_logo: company_logo || null,
//         company_phone_number: company_phone_number || "",
//         company_name: company_name || ""
//       });

//       // Set previews for file-based fields
//       if (company_logo) {
//         // setCompanyLogoPreview(`${company_logo}`);
//         setCompanyLogoPreview(company_logo.split('/').pop());
//       } else {
//         setCompanyLogoPreview('not provided'); // Display "null" if company_logo is not available
//       }
//       if (tender_file) {
//         setTenderFileName(tender_file.split('/').pop());
//       } else {
//         setTenderFileName('not provided'); // Display "null" if company_logo is not available
//       }

//     } catch (error) {
//       console.error('Error fetching tender data:', error);
//     }
//   };

//   useEffect(() => {
//     fetchTenderData();
//   }, [tenderID]);

//   const handleChange = e => {
//     const { name, type, files, value } = e.target;

//     if (type === 'file') {
//       const file = files[0];
//       if (name === 'tender_file') {
//         setFileName(file.name);
//       }

//       // Set the file name for company_logo
//       if (name === 'company_logo') {
//         setImageFile(file.name);
//       }
//       setFormData(prevData => ({
//         ...prevData,
//         [name]: file,
//       }));
//     } else {
//       setFormData(prevData => ({
//         ...prevData,
//         [name]: value,
//       }));
//     }
//   };

//   const handleSubmit = async e => {
//     e.preventDefault();

//     const formdata = new FormData();
//     formdata.append('name', formData.name);
//     formdata.append('tender_name', formData.tender_name);
//     formdata.append('phone', formData.phone);
//     formdata.append('email', formData.email);

//     // Check if a new tender file is selected, else append the existing file
//     if (formData.tender_file) {
//       formdata.append('tender_file', formData.tender_file);
//     } else if (tenderFileName && tenderFileName !== 'not provided') {
//       // If no new tender file is selected, keep the existing file
//       formdata.append('tender_file', tenderFileName);
//     }

//     // Check if a new company logo is selected, else append the existing logo
//     if (formData.company_logo) {
//       formdata.append('company_logo', formData.company_logo);
//     } else if (companyLogoPreview && companyLogoPreview !== 'not provided') {
//       // If no new company logo is selected, keep the existing logo
//       formdata.append('company_logo', companyLogoPreview);
//     }

//     formdata.append('designation', formData.designation);
//     formdata.append('organization_name', formData.organization_name);
//     formdata.append('company_phone_number', formData.company_phone_number);
//     formdata.append('company_name', formData.company_name);

//     try {
//       const apiEndpoint =
//         userType === 'end_user'
//           ? `/user/tender-end-user/tender-request/${tenderID}`
//           : userType === 'user'
//             ? `/user/tender-user/tender-request/${tenderID}`
//             : userType === 'affiliator'
//               ? `/affiliator/tender-request/publish-tender/${tenderID}`
//               : '';

//       const response = await apiClient.patch(apiEndpoint, formdata, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//         },
//       });
//       // console.log("update response:", response.data.message);
//       Swal.fire('Success!', response.data.message, 'success');
//     } catch (error) {
//       console.error('Error during submission:', error);
//       const errorMessage = error.response?.data?.message;
//       Swal.fire('Error!', errorMessage, 'error');
//     }
//   };

//   const handleRemovePDF = () => {
//     setFileName(""); // Clear the file name
//     document.getElementById("tender_file").value = ""; // Reset the file input
//   };

//   const handleRemovePic = () => {
//     setImageFile(""); // Clear the image file name
//     document.getElementById("company_logo").value = ""; // Reset the file input
//   };


//   return (
//     <div className="bg-publishTenderFormBackground p-4 2xl:p-6 border border-gray-400 rounded-md text-[10px] 2xl:text-xs">
//       <form onSubmit={handleSubmit} className="2xl:space-y-4 space-y-2">
//         {/* Tender Name Field */}
//         <div className="flex items-center flex-col md:flex-row lg:flex-row ">
//           <label
//             htmlFor="tender_name"
//             className="font-medium text-gray-700 w-full md:w-1/3"
//           >
//             Tender Name*
//           </label>
//           <input
//             id="tender_name"
//             name="tender_name"
//             type="text"
//             value={formData.tender_name}
//             onChange={handleChange}
//             placeholder="Enter tender's name"
//             required
//             className={`w-full md:w-2/3 p-2 border-2 border-gray-400 rounded shadow-sm  ${errors.tender_name ? 'border-red-500' : ''
//               }`}
//           />
//         </div>

//         {/* Company Name */}
//         <div className="flex items-center flex-col md:flex-row lg:flex-row ">
//           <label
//             htmlFor="company_name"
//             className="font-medium text-gray-700 w-full  md:w-1/3"
//           >
//             Company Name*
//           </label>
//           <input
//             id="company_name"
//             name="company_name"
//             type="text"
//             value={formData.company_name}
//             onChange={handleChange}
//             placeholder="Enter company name"
//             required
//             className={`w-full md:w-2/3  p-2 border-2 border-gray-400 rounded shadow-sm ${errors.company_name ? 'border-red-500' : ''
//               }`}
//           />
//         </div>

//         {/* company phone */}
//         <div className="flex items-center flex-col md:flex-row lg:flex-row ">
//           <label
//             htmlFor="phone"
//             className="font-medium text-gray-700 w-full  md:w-1/3"
//           >
//             Company Number *
//           </label>
//           <input
//             id="company_phone_number"
//             name="company_phone_number"
//             type="tel"
//             value={formData.company_phone_number}
//             onChange={handleChange}
//             placeholder="Enter your company phone number"
//             required
//             className={`w-full md:w-2/3 p-2 border-2 border-gray-400 rounded shadow-sm  ${errors.phone ? 'border-red-500' : ''
//               }`}
//           />
//         </div>

//         {/* Tender File */}
//         {/* <div className="flex items-center flex-col md:flex-row lg:flex-row">
//           <label
//             htmlFor="tender_file"
//             className="font-medium text-gray-700 w-full md:w-1/3"
//           >
//             Tender's File (PDF only/Image)*
//           </label>
//           <div className="w-full md:w-2/3 flex items-center  border-2  bg-white  border-gray-400 rounded shadow-sm p-1 ">
//             <input
//               type="text"
//               value={fileName || tenderFileName}
//               placeholder="Choose your tender file"
//               className="flex-1 w-full md:w-2/3  p-1  text-xs px-2"
//               readOnly
//               id="file_name_display"
//             />
//             <label
//               htmlFor="tender_file"
//               className="bg-publishTenderChoosePDF text-black px-4 py-1 text-xz rounded-md cursor-pointer hover:bg-publishTenderForm2 mx-2"
//             >
//               Choose PDF/Image
//             </label>
//             <input
//               id="tender_file"
//               name="tender_file"
//               type="file"
//               accept="application/pdf, image/png, image/jpeg, image/jpg"
//               onChange={handleChange}
//               className="hidden"
//             />
//           </div>
//         </div> */}
//         <div className="flex items-center flex-col md:flex-row lg:flex-row">
//           <label
//             htmlFor="tender_file"
//             className="font-semibold text-gray-700 w-full md:w-1/3"
//           >
//             Tender's File (PDF/Image)*
//           </label>
//           <div className="w-full md:w-2/3 flex items-center border-2 bg-white border-gray-400 rounded-md shadow-sm p-1">
//             <input
//               type="text"
//               value={fileName || tenderFileName}
//               placeholder="Choose your tender file"
//               className="flex-1 w-full md:w-2/3 p-2 px-2"
//               readOnly
//               id="file_name_display"
//               required
//             />
//             {/* Choose File Button */}
//             <label
//               htmlFor="tender_file"
//               className="bg-publishTenderChoosePDF text-black px-4 py-2 rounded-md cursor-pointer hover:bg-publishTenderFormBackground ml-2"
//             >
//               Choose PDF/Image
//             </label>
//             {/* Remove Button (conditionally rendered) */}
//             {fileName && (
//               <button
//                 type="button"
//                 onClick={handleRemovePDF}
//                 className="bg-red-500 text-white px-4 py-2 rounded-md cursor-pointer hover:bg-red-600 ml-2"
//               >
//                 Remove
//               </button>
//             )}
//             {/* Hidden File Input */}
//             <input
//               id="tender_file"
//               name="tender_file"
//               type="file"
//               accept="application/pdf, image/png, image/jpeg, image/jpg"
//               onChange={handleChange}
//               required
//               className="hidden"
//             />
//           </div>
//         </div>


//         {/* Company Logo */}
//         {/* <div className="flex items-center flex-col md:flex-row lg:flex-row">
//           <label
//             htmlFor="company_logo"
//             className=" font-medium text-gray-700 w-full md:w-1/3"
//           >
//             Company Logo
//           </label>
//           <div className="w-full md:w-2/3 flex items-center  border-2  bg-white  border-gray-400 rounded shadow-sm p-1 ">
//             <input
//               value={ImageFile || companyLogoPreview}
//               placeholder="Choose company logo"
//               className="flex-1 w-full md:w-2/3  p-1  text-xs px-2"
//               readOnly
//               id="company_name_display"
//             />
//             <label
//               htmlFor="company_logo"
//               className="bg-publishTenderChoosePDF text-black px-4 py-1 text-xz rounded-md cursor-pointer hover:bg-publishTenderForm2 mx-2"
//             >
//               Choose image
//             </label>
//             <input
//               id="company_logo"
//               name="company_logo"
//               type="file"
//               accept="image/*"
//               onChange={handleChange}
//               className="hidden"
//             />
//           </div>
//         </div> */}

//         <div className="flex items-center flex-col md:flex-row lg:flex-row">
//           <label
//             htmlFor="company_logo"
//             className="font-semibold text-gray-700 w-full md:w-1/3"
//           >
//             Company Logo
//           </label>
//           <div className="w-full md:w-2/3 flex items-center border-2 bg-white border-gray-400 rounded-md shadow-sm p-1">
//             <input
//                value={ImageFile || companyLogoPreview}
//               placeholder="Choose company logo"
//               className="flex-1 w-full md:w-2/3 p-2 px-2"
//               readOnly
//               id="company_name_display"
//               required
//             />
//             {/* Choose Image Button */}
//             <label
//               htmlFor="company_logo"
//               className="bg-publishTenderChoosePDF text-black px-4 py-2 rounded-md cursor-pointer hover:bg-publishTenderForm2 ml-2"
//             >
//               Choose image
//             </label>
//             {/* Remove Button (conditionally rendered) */}
//             {ImageFile && (
//               <button
//                 type="button"
//                 onClick={handleRemovePic}
//                 className="bg-red-500 text-white px-4 py-2 rounded-md cursor-pointer hover:bg-red-600 ml-2"
//               >
//                 Remove
//               </button>
//             )}
//             {/* Hidden File Input */}
//             <input
//               id="company_logo"
//               name="company_logo"
//               type="file"
//               accept="image/png, image/jpeg, image/jpg"
//               onChange={handleChange}
//               className="hidden"
//             />
//           </div>
//         </div>

//         {/* Name Field */}
//         <div className="flex items-center flex-col md:flex-row lg:flex-row ">
//           <label
//             htmlFor="name"
//             className="font-medium text-gray-700 w-full  md:w-1/3"
//           >
//             Name*
//           </label>
//           <input
//             id="name"
//             name="name"
//             type="text"
//             value={formData.name}
//             onChange={handleChange}
//             placeholder="Enter your name"
//             required
//             className={`w-full md:w-2/3  p-2 border-2 border-gray-400 rounded shadow-sm  ${errors.name ? 'border-red-500' : ''
//               }`}
//           />
//         </div>

//         {/* Phone Field */}
//         <div className="flex items-center flex-col md:flex-row lg:flex-row ">
//           <label
//             htmlFor="phone"
//             className=" font-medium text-gray-700 w-full  md:w-1/3"
//           >
//             Phone *
//           </label>
//           <input
//             id="phone"
//             name="phone"
//             type="tel"
//             value={formData.phone}
//             onChange={handleChange}
//             placeholder="Enter your phone number"
//             required
//             className={`w-full md:w-2/3 p-2 border-2 border-gray-400 rounded shadow-sm  ${errors.phone ? 'border-red-500' : ''
//               }`}
//           />
//         </div>

//         {/* Email Field */}
//         <div className="flex items-center flex-col md:flex-row lg:flex-row ">
//           <label
//             htmlFor="email"
//             className="font-medium text-gray-700 w-full  md:w-1/3"
//           >
//             Email
//           </label>
//           <input
//             id="email"
//             name="email"
//             type="email"
//             value={formData.email}
//             onChange={handleChange}
//             placeholder="Enter your email"
//             className={`w-full md:w-2/3  p-2 border-2 border-gray-400 rounded shadow-sm  ${errors.email ? 'border-red-500' : ''
//               }`}
//           />
//         </div>

//         {/* Organization Name Field */}
//         <div className="flex items-center flex-col md:flex-row lg:flex-row ">
//           <label
//             htmlFor="organization_name"
//             className=" font-medium text-gray-700 w-full md:w-1/3"
//           >
//             Organization Name
//           </label>
//           <input
//             id="organization_name"
//             name="organization_name"
//             type="text"
//             value={formData.organization_name}
//             onChange={handleChange}
//             placeholder="Enter your institute"
//             className={`w-full md:w-2/3  p-2 border-2 border-gray-400 rounded shadow-sm  ${errors.organization_name ? 'border-red-500' : ''
//               }`}
//           />
//         </div>

//         {/* Designation Field */}
//         <div className="flex items-center flex-col md:flex-row lg:flex-row ">
//           <label
//             htmlFor="designation"
//             className="font-medium text-gray-700 w-full  md:w-1/3"
//           >
//             Designation
//           </label>
//           <input
//             id="designation"
//             name="designation"
//             type="text"
//             value={formData.designation}
//             onChange={handleChange}
//             placeholder="Enter your designation"
//             className={`w-full md:w-2/3  p-2 border-2 border-gray-400 rounded shadow-sm ${errors.designation ? 'border-red-500' : ''
//               }`}
//           />
//         </div>

//         <div className="flex justify-end">
//           <button
//             type="submit"
//             className="px-6 py-2 bg-orange-400 text-white rounded hover:bg-green-600 transition"
//           >
//             Update Tender
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default TenderRequestUpdateForm;






// {tenderFileName && (
//   <div className="flex flex-col md:flex-row md:items-center md:space-x-4">
//     <label
//       htmlFor="company_logo"
//       className="block  font-medium text-gray-700 md:w-1/3 md:mb-0 mb-1"
//     >
//       Previous Tender File
//     </label>
//     <p className=" text-gray-500 p-2">{tenderFileName}</p>
//   </div>
// )}

// {companyLogoPreview && (
//   <div className="flex flex-col md:flex-row md:items-center md:space-x-4">
//     <label
//       htmlFor="company_logo"
//       className="block font-medium text-gray-700 md:w-1/3 md:mb-0 mb-1"
//     >
//       Previous Logo
//     </label>
//     <p className=" text-gray-500 p-2">{companyLogoPreview}</p>
//   </div>
// )}

// import React, { useState, useEffect } from 'react';
// import PostYourTenderLogo from '../../Assets/images/PostYourTenderLogo.png';
// import apiClient from '../../Api/apiClient';
// import Swal from 'sweetalert2';

// const TenderRequestUpdateForm = ({ tenderID }) => {
//   const [formData, setFormData] = useState({
//     name: '',
//     phone: '',
//     email: '',
//     designation: '',
//     organization_name: '',
//     tender_name: '',
//     tender_file: null,
//     company_logo: null,
//   });

//   const [errors, setErrors] = useState({});

//   // Fetch tender data based on tenderID
//   const fetchTenderData = async () => {
//     if (!tenderID) return; // Skip if no tender ID is selected

//     try {
//       const response = await apiClient.get(
//         `/user/tender-user/tender-request/${tenderID}`
//       );
//       const {
//         name,
//         email,
//         phone,
//         designation,
//         organization_name,
//         tender_name,
//         tender_file,
//         company_logo,
//       } = response.data.data;

//       console.log(response.data.data);
//       setFormData({
//         name: name || '',
//         email: email || '',
//         phone: phone || '',
//         designation: designation || '',
//         organization_name: organization_name || '',
//         tender_name: tender_name || '',
//         tender_file: tender_file || null,
//         company_logo: company_logo || null,
//         //  setNidImage(
//         //    response.data.nidcard_picture
//         //      ? // ? // ? `${response.data.nidcard_picture}`
//         //        //   `/` + response.data.nidcard_picture.split('/').pop()
//         //        // : null
//         //        `${baseUrl}${response.data.nidcard_picture}`
//         //      : null
//         //  );
//       });
//     } catch (error) {
//       console.error('Error fetching tender data:', error);
//     }
//   };

//   useEffect(() => {
//     fetchTenderData();
//   }, [tenderID]); // Re-fetch data whenever tenderID changes

//   const handleChange = e => {
//     const { name, files } = e.target;

//     if (files && files.length > 0) {
//       setFormData(prevData => ({
//         ...prevData,
//         [name]: files[0],
//       }));
//     } else {
//       setFormData(prevData => ({
//         ...prevData,
//         [name]: e.target.value,
//       }));
//     }
//   };

//   const handleSubmit = async e => {
//     e.preventDefault();

//     const formdata = new FormData();
//     formdata.append('name', formData.name);
//     formdata.append('tender_name', formData.tender_name);
//     formdata.append('phone', formData.phone);
//     formdata.append('email', formData.email);
//     formdata.append('tender_file', formData.tender_file);
//     if (formData.company_logo) {
//       formdata.append('company_logo', formData.company_logo);
//     }
//     formdata.append('designation', formData.designation);
//     formdata.append('organization_name', formData.organization_name);

//     try {
//       const response = await apiClient.patch(
//         `/user/tender-user/tender-request/${tenderID}`,
//         formdata,
//         {
//           headers: {
//             'Content-Type': 'multipart/form-data',
//           },
//         }
//       );

//       Swal.fire('Success!', response.data.message, 'success');
//     } catch (error) {
//       console.error('Error during submission:', error);
//       Swal.fire('Error!', 'Failed to update the tender.', 'error');
//     }
//   };

//   return (
//     <div className="bg-tenderDetails p-4 2xl:p-6 border border-gray-400 rounded-md shadow-lg">
//       <p className="text-gray-600 mb-7 text-left text-sm md:text-lg">
//         Post RFQs, private tenders, and auction notices here to drive
//         competitive pricing and quality.
//       </p>
//       <form onSubmit={handleSubmit} className="2xl:space-y-6 space-y-3">
//         {/* Render each form field */}
//         {[
//           {
//             label: 'Person Name',
//             id: 'name',
//             type: 'text',
//             placeholder: 'Enter your name',
//             required: true,
//           },
//           {
//             label: 'Phone Number',
//             id: 'phone',
//             type: 'tel',
//             placeholder: 'Enter your phone number',
//             required: true,
//           },
//           {
//             label: 'Email',
//             id: 'email',
//             type: 'email',
//             placeholder: 'Enter your email',
//             required: true,
//           },
//           {
//             label: 'Designation',
//             id: 'designation',
//             type: 'text',
//             placeholder: 'Enter your designation',
//           },
//           {
//             label: 'Organization name',
//             id: 'organization_name',
//             type: 'text',
//             placeholder: 'Enter your institute',
//           },
//           {
//             label: 'Tender Name',
//             id: 'tender_name',
//             type: 'text',
//             placeholder: "Enter tender's name",
//             required: true,
//           },
//           {
//             label: "Tender's File (PDF only)",
//             id: 'tender_file',
//             type: 'file',
//             required: true,
//           },
//           {
//             label: 'Company Logo',
//             id: 'company_logo',
//             name: 'company_logo',
//             type: 'file',
//             required: true,
//           },
//         ].map((field, idx) => (
//           <div
//             key={idx}
//             className="flex flex-col md:flex-row md:items-center md:space-x-4"
//           >
//             <label
//               htmlFor={field.id}
//               className="block md:text-sm text-xs font-medium text-gray-700 md:w-1/3 md:mb-0 mb-1"
//             >
//               {field.label}
//             </label>
//             <input
//               id={field.id}
//               name={field.id}
//               type={field.type}
//               value={field.type !== 'file' ? formData[field.id] : undefined}
//               onChange={handleChange}
//               placeholder={field.placeholder}
//               // required={field.required}
//               className={`flex-1 p-2 border-2 border-gray-400 rounded-md shadow-sm focus:border-blue-500 focus:ring-blue-500 text-xs bg-white ${
//                 errors[field.id] ? 'border-red-500' : ''
//               }`}
//             />

//           </div>
//         ))}
//         {errors.submit && (
//           <p className="text-red-500 text-xs text-center">{errors.submit}</p>
//         )}
//         <div className="flex justify-end ">
//           <button
//             type="submit"
//             className="px-6 py-2 bg-green-500 text-white rounded-md hover:bg-green-600 transition"
//           >
//             Update Tender
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default TenderRequestUpdateForm;

// import React, { useState, useEffect } from 'react';
// import PostYourTenderLogo from '../../Assets/images/PostYourTenderLogo.png';
// import apiClient from '../../Api/apiClient';
// import Swal from 'sweetalert2';

// const TenderRequestUpdateForm = () => {
//   const [formData, setFormData] = useState({
//     name: '',
//     phone: '',
//     email: '',
//     designation: '',
//     organization_name: '',
//     tender_name: '',
//     tender_file: null,
//     company_logo: null,
//   });

//   const [errors, setErrors] = useState({});
//   // Handle form field changes

//   // Fetch profile data if authenticated
//   const fetchProfileData = async () => {
//       try {
//         const response = await apiClient.get(
//           '/user/tender-user/tender-request/94'
//         );
//         const { full_name, email, phone, designation, organization_name, tender_name } =
//           response.data.data;

//         setFormData(prevData => ({
//           ...prevData,
//           name: prevData.name || full_name || '',
//           email: prevData.email || email || '',
//           phone: prevData.phone || phone || '',
//           designation: prevData.designation || designation || '',
//           organization_name:
//             prevData.organization_name || organization_name || '',
//         }));
//       } catch (error) {
//         console.error('Error fetching profile data:', error);
//       }

//   };

//   useEffect(() => {
//     fetchProfileData();
//   }, []);

//   const handleChange = e => {
//     const { name, files } = e.target;

//     // If files are selected
//     if (files && files.length > 0) {
//       const file = files[0];

//       // Validate the file type for tender_file (only PDF allowed)
//       if (name === 'tender_file') {
//         if (file.type !== 'application/pdf') {
//           Swal.fire({
//             title: 'Not Accept!',
//             text: 'Please upload a valid PDF file.',
//             customClass: {
//               popup: 'w-72 h-auto p-3',
//               title: 'text-sm',
//               content: 'text-xs',
//               confirmButton:
//                 'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
//             },
//           });
//           setErrors(prevErrors => ({
//             ...prevErrors,
//             tender_file: 'Please upload a valid PDF file.',
//           }));
//           e.target.value = null; // Clear the input to prevent uploading invalid file
//           return;
//         } else {
//           // No errors if the file is a valid PDF
//           setErrors(prevErrors => ({
//             ...prevErrors,
//             tender_file: '',
//           }));
//         }
//       }

//       // Validate the file type for company_logo (only PNG or JPEG allowed)
//       if (
//         name === 'company_logo' &&
//         !['image/png', 'image/jpeg'].includes(file.type)
//       ) {
//         setErrors(prevErrors => ({
//           ...prevErrors,
//           company_logo: 'Please upload a valid image (PNG or JPEG).',
//         }));
//         e.target.value = null; // Clear the input to prevent uploading invalid file
//         return;
//       } else {
//         // Clear error if the file is valid
//         setErrors(prevErrors => ({
//           ...prevErrors,
//           company_logo: '',
//         }));
//       }

//       // Update formData with the file
//       setFormData(prevData => ({
//         ...prevData,
//         [name]: file, // Store the raw File object
//       }));
//     } else {
//       // Handle non-file inputs (text, email, etc.)
//       setFormData(prevData => ({
//         ...prevData,
//         [name]: e.target.value,
//       }));
//     }
//   };

//   const handleSubmit = async e => {
//     e.preventDefault();

//     // Prepare FormData
//     const formdata = new FormData();
//     formdata.append('name', formData.name);
//     formdata.append('tender_name', formData.tender_name);
//     formdata.append('phone', formData.phone);
//     formdata.append('email', formData.email);
//     formdata.append('tender_file', formData.tender_file); // Append raw File
//     if (formData.company_logo) {
//       formdata.append('company_logo', formData.company_logo); // Append optional logo
//     }
//     formdata.append('designation', formData.designation);
//     formdata.append('organization_name', formData.organization_name);

//     // Submit the data
//     try {
//       const response = await apiClient.patch(
//         `/user/tender-user/tender-request/96`,
//         formdata,
//         {
//           headers: {
//             'Content-Type': 'multipart/form-data',
//           },
//         }
//       );

//       const successMessage = response.data.message;
//       Swal.fire({
//         title: 'Success!',
//         text: successMessage,
//         customClass: {
//           popup: 'w-72 h-auto p-3',
//           title: 'text-sm',
//           content: 'text-xs',
//           confirmButton: 'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
//         },
//       });
//       // Clear form fields
//       setFormData({
//         tender_name: '',
//         tender_file: '',
//         company_logo: '',
//       });
//     } catch (error) {
//       console.error('Error during submission:', error);
//       const errorMessage = error.response?.data.message || 'An error occurred';
//       Swal.fire({
//         title: 'Failed to submit the form',
//         text: errorMessage,
//         customClass: {
//           popup: 'w-72 h-auto p-3',
//           title: 'text-sm',
//           content: 'text-xs',
//           confirmButton: 'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
//         },
//       });
//     }
//   };

//   return (
// <div className="bg-publishTender p-6 border border-gray-400 rounded-md shadow-lg">
//   <p className="text-gray-600 mb-7 text-left text-sm md:text-lg">
//     Post RFQs, private tenders, and auction notices here to drive
//     competitive pricing and quality.
//   </p>
//   <form onSubmit={handleSubmit} className="2xl:space-y-6 space-y-3">
//     {/* Render each form field */}
//     {[
//       {
//         label: 'Person Name',
//         id: 'name',
//         type: 'text',
//         placeholder: 'Enter your name',
//         required: true,
//       },
//       {
//         label: 'Phone Number',
//         id: 'phone',
//         type: 'tel',
//         placeholder: 'Enter your phone number',
//         required: true,
//       },
//       {
//         label: 'Email',
//         id: 'email',
//         type: 'email',
//         placeholder: 'Enter your email',
//         required: true,
//       },
//       {
//         label: 'Designation',
//         id: 'designation',
//         type: 'text',
//         placeholder: 'Enter your designation',
//       },
//       {
//         label: 'Organization name',
//         id: 'organization_name',
//         type: 'text',
//         placeholder: 'Enter your institute',
//       },
//       {
//         label: 'Tender Name',
//         id: 'tender_name',
//         type: 'text',
//         placeholder: "Enter tender's name",
//         required: true,
//       },
//       {
//         label: "Tender's File (PDF only)",
//         id: 'tender_file',
//         type: 'file',
//         required: true,
//       },
//       {
//         label: 'Company Logo',
//         id: 'company_logo',
//         name: 'company_logo',
//         type: 'file',
//         required: true,
//       },
//     ].map((field, idx) => (
//       <div
//         key={idx}
//         className="flex flex-col md:flex-row md:items-center md:space-x-4"
//       >
//         <label
//           htmlFor={field.id}
//           className="block md:text-sm text-xs font-medium text-gray-700 md:w-1/3 md:mb-0 mb-1"
//         >
//           {field.label}
//         </label>
//         <input
//           id={field.id}
//           name={field.id}
//           type={field.type}
//           value={field.type !== 'file' ? formData[field.id] : undefined}
//           onChange={handleChange}
//           placeholder={field.placeholder}
//           // required={field.required}
//           className={`flex-1 p-2 border-2 border-gray-400 rounded-md shadow-sm focus:border-blue-500 focus:ring-blue-500 text-xs bg-white ${
//             errors[field.id] ? 'border-red-500' : ''
//           }`}
//         />
//         {/* {errors[field.id] && (
//           <p className="text-red-500 text-xs">{errors[field.id]}</p>
//         )} */}
//       </div>
//     ))}
//     {errors.submit && (
//       <p className="text-red-500 text-xs text-center">
//         {errors.submit}
//       </p>
//     )}
//     <div className="flex justify-end ">
//       <button
//         type="submit"
//         className="px-6 py-2 bg-publishTenderBtn text-white rounded-md font-semibold hover:bg-yellow-600 transition"
//       >
//         Update Tender
//       </button>
//     </div>
//   </form>
// </div>
//   );
// };

// export default TenderRequestUpdateForm;
